export enum Role {
  ShinseishaKanri = "USE1",
  ShinseishaIppan = "USE2",
  ShoninshaKanri = "ULT1",
  ShoninshaIppan = "ULT2",
}

export const SHINSEISHA_LIST = [Role.ShinseishaIppan, Role.ShinseishaKanri];
export const SHONINSHA_LIST = [Role.ShoninshaIppan, Role.ShoninshaKanri];

export enum Kengen {
  管理 = "1",
  一般 = "2",
}
